<p-panel [header]="showUpload ? 'Enviar Anexos' : 'Anexos'" *ngIf="showUpload || anexosList.length > 0">
  <div class="col-12 p-1">
    <div class="col-12">
      <div *ngIf="anexosList.length == 0">
        <p-message severity="warn" text="Nenhum anexo enviado."></p-message>
      </div>
      <span class="label" *ngIf="anexosList.length > 0">
        <i class="mr-3 fa fa-paperclip"></i>Anexos
        {{ showUpload ? "guardados" : "" }}</span
      ><br />
      <ul>
        <li *ngFor="let anexo of anexosList">
          <button
            type="button"
            class="btn btn-link p-0"
            (click)="realizarDownload(anexo)"
            title="Clique para baixar {{ anexo.nome }}"
          >
            {{ anexo.nome }}<i class="mr-0 fa fa-circle-down"></i>
          </button>
          <button
            *ngIf="showUpload"
            type="button"
            class="btn btn-link p-0 text-danger"
            (click)="removerAnexo(anexo)"
            title="Remover anexo"
          >
            <i class="mr-3 fa fa-trash"></i>
          </button>
        </li>
      </ul>
    </div>
    <div class="col-12" *ngIf="showUpload">
      <div class="br-upload">
        <label class="upload-label" for="multiple-files"
          ><span>Envio de anexos</span></label
        ><input
          class="upload-input"
          #fileInput
          id="multiple-files"
          type="file"
          accept="{{ accept }}"
          multiple="multiple"
          aria-hidden="null"
          aria-label="enviar arquivo"
          (change)="handleFile($event)"
        />
        <button
          [disabled]="obterTotalAnexos() > 4"
          (click)="addFile()"
          (drop)="handleDrop($event)"
          [class.drag-over]="isDragging"
          (dragenter)="onDragEnter($event)"
          (dragleave)="onDragLeave($event)"
          (dragover)="onDragOver($event)"
          (dragend)="onDragLeave($event)"
          class="upload-button"
          type="button"
          aria-hidden="true"
        >
          <i class="fas fa-upload" aria-hidden="true"></i
          ><span>Selecione o(s) arquivo(s)</span>
        </button>
        <div class="upload-list">
          <!-- @for(item of filesRecords; track item.name; let index = $index){ -->
          <div
            class="br-item d-flex"
            *ngFor="let item of filesRecords; let index = index"
          >
            <div
              [title]="item.name"
              class="content text-primary-default mr-auto"
            >
              {{ item.name }}
            </div>
            <div class="name"></div>
            <div
              class="br-tooltip"
              role="tooltip"
              place="top"
              info="info"
              data-popper-placement="top"
              style="
                position: absolute;
                inset: auto auto 0px 0px;
                margin: 0px;
                transform: translate(121px, -102px);
              "
            >
              <span class="text" role="tooltip">{{ item.name }}</span>
              <!-- <div
										data-popper-arrow=""
										class="arrow"
										style="
											position: absolute;
											left: 0px;
											transform: translate(33px, 0px);
										"
									></div> -->
              <!-- <div data-popper-arrow=""></div> -->
            </div>
            <div class="support mr-n2">
              <span class="mr-1">{{ calcSize(item.size) }}</span
              ><button
                class="br-button"
                type="button"
                circle=""
                [title]="'apagar ' + item.name"
                [attr.aria-label]="'apagar ' + item.name"
                (click)="handleRemoveFile(index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
          <!-- } -->
        </div>
      </div>
      <p>
        <span class="feedback info mt-1" *ngIf="!alerta.show" role="alert"
          ><i class="fas fa-info-circle" aria-hidden="true"></i>É permitido anexar até 5 arquivos PDF por anúncio, com tamanho máximo de 30 MB cada.</span
        >
      </p>
      <p>
        <span class="feedback danger mt-1" role="alert" *ngIf="alerta.show"
          ><i class="fas fa-times-circle" aria-hidden="true"></i
          >{{ alerta.mensagem }}</span
        >
      </p>
    </div>
    <div
      class="col-12 buttons justify-content-start mb-3  flex"
      *ngIf="showUpload && filesRecords.length > 0"
    >
      <button
        type="button"
        pButton
        icon="fa fa-save"
        label="Guardar anexos"
        class="ui-button-secondary"
        (click)="realizarUpload()"
      ></button>

    </div>
      <p *ngIf="showUpload && filesRecords.length > 0">
        <span class="feedback warning mt-1" role="alert"
          >Para prosseguir, salve os arquivos selecionados clicando em “Guardar anexos”</span
        >
      </p>
  </div>
</p-panel>
